(() => {
  'use strict';
  const root = document.querySelector('.sj-mariner-main');
  if (!root || root.dataset.sjMarinerBound) return;
  root.dataset.sjMarinerBound = 'true';
  document.body.dataset.sjProduct = location.pathname.split('/products/')[1]?.split('/')[0] || '';
  const sticky = document.querySelector('.sj-mariner-sticky');
  const mainButton = () => root.querySelector('.x-block-buy-buttons button[name="add"]');
  const setText = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  let pending = false;

  function selectedFinish() {
    const groups = [...root.querySelectorAll('.x-variant-picker fieldset')]
      .filter(group => group.querySelector('input[type="radio"]'));
    const values = groups.map(group => group.querySelector('input[type="radio"]:checked')?.value);
    if (values.some(value => !value)) return '';
    return values.length ? values.join(' / ') : 'Ready to add';
  }

  function mount() {
    // Eurus replaces buying blocks after a variant changes. Reattach only what is missing.
    const button = mainButton();
    const payment = root.querySelector('.payment-button-container');
    // Native wallets and their Shop Promise slot stay exposed, not gated by a disclosure.
    const oldDisclosure = payment?.closest('.sj-mariner-express');
    if (oldDisclosure) {
      oldDisclosure.before(payment);
      oldDisclosure.remove();
    }
    const installment = root.querySelector('.shopify-payment-terms');
    const buy = root.querySelector('.x-block-buy-buttons');
    if (installment && buy && installment.parentElement !== buy) buy.append(installment);
    if (button && buy && !root.querySelector('.sj-mariner-service')) {
      const service = document.querySelector('#sj-mariner-service-template').content.firstElementChild.cloneNode(true);
      buy.append(service);
    }

    const finish = selectedFinish();
    const legend = root.querySelector('.x-variant-picker legend');
    if (!finish && legend && legend.textContent.trim() === 'Finish') setText(legend, 'Finish: choose an option');
    if (finish && legend && legend.textContent.trim() === 'Finish: choose an option') setText(legend, 'Finish: ' + finish);
    setText(sticky?.querySelector('[data-sj-sticky-finish]'), finish || 'Choose your options');
    const price = root.querySelector('.x-block-price [role="status"]');
    if (price) setText(sticky?.querySelector('[data-sj-sticky-price]'), price.innerText.trim());
    const stickyButton = sticky?.querySelector('button');
    if (stickyButton && button) {
      setText(stickyButton, finish ? (button.querySelector('.x-atc-text')?.innerText.trim() || 'Add to bag') : 'Choose options');
      stickyButton.disabled = Boolean(finish && button.disabled);
    }
    const walletWrap = sticky?.querySelector('.sj-mariner-sticky-wallet-wrap');
    const walletForm = sticky?.querySelector('form');
    if (walletWrap && walletForm) {
      const variant = root.querySelector('.x-block-buy-buttons form[data-type="add-to-cart-form"] input[name="id"]')?.value;
      const quantity = root.querySelector('.x-quantity-selector input[name="quantity"]')?.value || '1';
      const variantInput = walletForm.querySelector('input[name="id"]');
      const quantityInput = walletForm.querySelector('input[name="quantity"]');
      if (variant && variantInput.value !== variant) {
        variantInput.value = variant;
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
      }
      if (quantityInput.value !== quantity) {
        quantityInput.value = quantity;
        quantityInput.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const locked = !finish || !button || button.disabled;
      walletWrap.inert = locked;
      walletWrap.classList.toggle('is-locked', locked);
      walletWrap.setAttribute('aria-disabled', String(locked));
    }
    const gallery = root.querySelector('.swiper-product');
    const count = root.querySelector('.sj-mariner-gallery-count');
    const slides = gallery?.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
    const active = gallery?.querySelector('.splide__list > .splide__slide.is-active');
    if (count && slides?.length) {
      const index = Array.from(slides).indexOf(active);
      setText(count, `${Math.max(1, index + 1)} / ${slides.length}`);
    }
    // The existing theme moves the standalone badge section into product info.
    document.querySelectorAll('[id*="ss_trust_badges_pro"]').forEach(section => {
      if (!section.hasAttribute('data-sj-mariner-hide-badges')) section.setAttribute('data-sj-mariner-hide-badges', '');
    });
    document.querySelectorAll('.ss-trust-badge, #ss-trust-badge').forEach(section => {
      if (!section.hasAttribute('data-sj-mariner-hide-badges')) section.setAttribute('data-sj-mariner-hide-badges', '');
    });
    const reviews = document.querySelector('[id*="175440762204bbbb7d"]');
    const recommendations = document.getElementById('rebuy-widget-271946')?.closest('[id^="shopify-section-"]');
    if (reviews && recommendations && recommendations.nextElementSibling !== reviews) recommendations.after(reviews);
    const oldLooks = document.querySelector('[id*="metafield_complete_look_D9cPfk"]');
    const lookTemplate = document.getElementById('sj-mariner-looks-template');
    if (oldLooks && lookTemplate && !document.querySelector('.sj-mariner-looks')) {
      const looks = lookTemplate.content.firstElementChild.cloneNode(true);
      oldLooks.before(looks);
      oldLooks.setAttribute('data-sj-looks-replaced', '');
      looks.querySelectorAll('[data-sj-open-look]').forEach(opener => {
        const dialog = looks.querySelector('#' + opener.dataset.sjOpenLook);
        opener.addEventListener('click', () => dialog.showModal());
        dialog.querySelector('[data-sj-close-look]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
        dialog.addEventListener('keydown', e => {
          if (e.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('button:not([disabled]),a[href]:not([tabindex="-1"])')]
            .filter(el => el.getClientRects().length);
          const first = items[0], last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last?.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first?.focus();
          }
        });
        dialog.addEventListener('click', e => {
          const rect = dialog.getBoundingClientRect();
          if (e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) dialog.close();
        });
      });
    }
    const rebuy = document.getElementById('rebuy-widget-271946');
    if (rebuy) {
      setText(rebuy.querySelector('.primary-title'), 'You May Also Like');
      rebuy.querySelectorAll('.rebuy-product-block').forEach(card => {
        const productLink = card.querySelector('.rebuy-product-title a');
        if (productLink && !card.querySelector('.sj-rebuy-options')) {
          const link = document.createElement('a');
          link.className = 'sj-rebuy-options';
          const destination = new URL(productLink.href, location.origin);
          destination.searchParams.delete('variant');
          link.href = destination.href;
          link.textContent = 'Choose options';
          link.setAttribute('aria-label', 'Choose options for ' + productLink.textContent.trim());
          card.append(link);
        }
      });
    }
    updateSticky();
  }

  function updateSticky() {
    if (!sticky) return;
    const previewBar = document.getElementById('PBarNextFrameWrapper');
    const previewOffset = previewBar ? Math.max(0, previewBar.getBoundingClientRect().height) : 0;
    const previewValue = previewOffset + 'px';
    if (document.body.style.getPropertyValue('--sj-preview-offset') !== previewValue) {
      document.body.style.setProperty('--sj-preview-offset', previewValue);
    }
    const button = mainButton();
    const pastButton = Boolean(button && button.getBoundingClientRect().bottom < 80);
    const bounds = button?.getBoundingClientRect();
    document.body.classList.toggle('sj-mariner-primary-visible', Boolean(bounds && bounds.top < innerHeight && bounds.bottom > 80));
    const cartOpen = document.getElementById('rebuy-cart')?.classList.contains('is-visible')
      || document.querySelector('.rebuy-cart__flyout[aria-hidden="false"]');
    const footer = document.querySelector('footer');
    const atFooter = footer && footer.getBoundingClientRect().top < innerHeight - 80;
    sticky.classList.toggle('is-visible', Boolean(pastButton && !cartOpen && !atFooter));
  }

  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; mount(); });
  }
  sticky?.querySelector('button')?.addEventListener('click', () => {
    if (!selectedFinish()) {
      const picker = root.querySelector('.x-variant-picker');
      picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker?.querySelector('input[type="radio"] + label, label')?.focus();
      mainButton()?.click(); // Keep the site's native validation and prompt.
    } else {
      mainButton()?.click(); // One source of truth for finish, quantity and cart.
    }
  });
  // Observe the stable product-page host, not only an already-mounted widget.
  // Rebuy can arrive after initialization/load; its heading, links and position
  // must still normalize. Attribute changes are intentionally excluded.
  new MutationObserver(queue).observe(root.closest('main') || root, {childList:true,subtree:true});
  const galleryList = root.querySelector('.swiper-product .splide__list');
  if (galleryList) new MutationObserver(queue).observe(galleryList, { attributes: true, subtree: true, attributeFilter: ['class'] });
  const cart = document.getElementById('rebuy-cart');
  if (cart) new MutationObserver(updateSticky).observe(cart, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  // Native family labels already support pointer selection; add an equivalent
  // keyboard action without replacing the underlying native radio/change path.
  root.addEventListener('keydown', e => {
    const label = e.target.closest('label.sj-family-toned-option');
    if (label && (e.key === 'Enter' || e.key === ' ') && !e.repeat) {
      e.preventDefault();
      label.click();
    }
  });
  root.addEventListener('change', queue);
  root.addEventListener('input', queue);
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('load', queue, { once: true });
  document.addEventListener('eurus:media-gallery-ready:' + root.dataset.sjSection, queue);
  mount();
})();


/* Progressive enhancement for hosted main-PDP videos only. */
(() => {
  'use strict';
  const config = document.getElementById('sj-pdp-video-settings');
  const root = document.querySelector('.sj-mariner-main');
  if (!config || !root) return;
  const options = JSON.parse(config.textContent);

  function bind(video) {
    if (!video.dataset.sjMuteDefault) {
      video.dataset.sjMuteDefault = 'true';
      if (options.startMuted !== false) {
        video.defaultMuted = true;
        video.muted = true;
      }
    }
    if (options.compactControls === false) return;
    if (video.dataset.sjCompactBound) return;
    const slide = video.closest('.media-slide');
    const container = video.closest('.external-video');
    if (!slide || !container || video.closest('[role="dialog"]')) return;
    video.dataset.sjCompactBound = 'true';
    const bar = document.createElement('div');
    bar.className = 'sj-video-controls';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Product video controls');
    const createButton = () => {
      const button = document.createElement('button');
      button.type = 'button';
      bar.append(button);
      return button;
    };
    const play = createButton(), sound = createButton(), native = createButton();
    const write = (button, text, label) => {
      if (button.textContent !== text) button.textContent = text;
      button.setAttribute('aria-label', label);
    };
    function sync() {
      write(play, video.paused ? 'Play' : 'Pause', video.paused ? 'Play product video' : 'Pause product video');
      write(sound, video.muted ? 'Unmute' : 'Mute', video.muted ? 'Unmute product video' : 'Mute product video');
      sound.setAttribute('aria-pressed', String(video.muted));
      write(native, video.controls ? 'Compact' : 'Full player', video.controls ? 'Use compact video controls' : 'Show full video controls for seeking and fullscreen');
      native.setAttribute('aria-pressed', String(video.controls));
    }
    function fallback() {
      video.controls = true;
      container.classList.remove('sj-video-enhanced');
      bar.remove();
    }
    play.addEventListener('click', () => {
      if (video.paused) {
        container.classList.remove('function-paused');
        video.play().catch(fallback);
      } else {
        container.classList.add('function-paused');
        video.pause();
      }
    });
    sound.addEventListener('click', () => { video.muted = !video.muted; sync(); });
    native.addEventListener('click', () => { video.controls = !video.controls; sync(); });
    // Keep controls outside the native click-to-toggle wrapper and drag handler.
    bar.addEventListener('click', event => event.stopPropagation());
    bar.addEventListener('pointerdown', event => event.stopPropagation());
    video.addEventListener('playing', () => {
      container.querySelectorAll('.img-thumbnail, .button-play').forEach(el => el.classList.add('hidden'));
      sync();
    });
    ['play', 'pause', 'ended', 'volumechange'].forEach(event => video.addEventListener(event, sync));
    video.addEventListener('error', fallback, {once: true});
    container.append(bar);
    container.classList.add('sj-video-enhanced');
    // Native controls remain the fallback until accessible replacements exist.
    video.controls = false;
    sync();
  }
  function mount() {
    root.querySelectorAll('video').forEach(bind);
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; mount(); });
  }).observe(root, {childList: true, subtree: true});
  mount();
})();
